import React, { Component } from 'react';

import NormDetail from './NormDetail';
import NormForm from './NormForm';

class NormDetailView extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }


  renderContent() {
    const { type = 'detail', rest, templateType, onEdit } = this.props;
    
    if(type === 'detail') {
      return <NormDetail {...rest} templateType={templateType} />
    }
    if(type === 'form') {
      return <NormForm {...rest} templateType={templateType} onEdit={onEdit} />
    }
    return null;
  }

  render() {
    return (
      <div style={{marginBottom: 24}}>
        {this.renderContent()}
      </div>
    )
  }
}

export default NormDetailView;